export const news = {
  gaAction: 'News',
  gaCategory: PAGE_SCRIPTS.page_template,
  init() {
    $(document).on('click', '.js-news-cta', e => {
      /* Tracking event when clicking on the "See more" CTA */
      Tracking.dataLayerPush({
        clickCode: 'clickNewsCTA',
        gaCategory: this.gaCategory,
        gaAction: this.gaAction,
        gaLabel: $(e.currentTarget).text().trim(),
        event: 'clickCTA'
      });
    }).on('click', '.js-news .js-lge', e => {
      /* Tracking event when clicking on a single news encart */
      const $target = $(e.currentTarget);
      Tracking.dataLayerPush({
        clickCode: 'clickLinkNews',
        gaCategory: this.gaCategory,
        gaAction: this.gaAction,
        gaLabel: $target.find('.js-news-elem--title').text().trim(),
        gaValue: ($target.index() + 1).toString(),
        event: 'clickEvent'
      });
    });
  }
};